import { render, staticRenderFns } from "./AvueExplainDemo.vue?vue&type=template&id=258b283f&scoped=true"
import script from "./AvueExplainDemo.vue?vue&type=script&lang=js"
export * from "./AvueExplainDemo.vue?vue&type=script&lang=js"
import style0 from "./AvueExplainDemo.vue?vue&type=style&index=0&id=258b283f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258b283f",
  null
  
)

export default component.exports